import { createBrowserRouter } from "react-router-dom";

import HomePage from "../pages/home_page/HomePage.tsx";
import InfoPage from "../pages/infos_page/InfosPage.tsx";

import App from "../App.tsx";
import EnDevelopment from "../components/EnDevelopment.tsx";
import NotFound from "../components/NotFound.tsx";
import PricingPage from "../pages/pricing_page/PricingPage.tsx";
import ContactPage from "../pages/contact_page/ContactPage.tsx";
import DemoLogin from "../pages/demo_page/DemoLogin.tsx";
import DemoPage from "../pages/demo_page/DemoPage.tsx";
import Progress from "../pages/demo_page/Progress.tsx";
import DemoSections from "../pages/demo_page/DemoSections.tsx";
import { load } from "../loaders/plansLoader.ts";
import SupportPage from "../pages/support_page/SupportPage.tsx";
import Legal_Disclairmer from "../pages/Legal_Disclaimer/legal_disclaimer.tsx";
import PrivacyPage from "../pages/privacy/PrivacyPage.tsx";
import ConditionPage from "../pages/conditions/ConditionPage.tsx";
import Faq from "../pages/faq_page/Faq.tsx";
import Ressource from "../pages/ressource_page/Ressource.tsx";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <NotFound />,
    children: [
      {
        path: "",
        element: <HomePage />,
      },
      {
        path: "infos",
        element: <InfoPage />,
      },
      {
        path: "pricing",
        loader: load,
        element: <PricingPage />,
      },
      {
        path: "demo",
        element: <DemoPage />,
      },
      {
        path: "demo/progress",
        element: <Progress />,
      },
      {
        path: "demo/sections",
        element: <DemoSections />,
      },
      {
        path: "demologin",
        element: <DemoLogin />,
      },
      
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "legal-disclaimer",
        element: <Legal_Disclairmer />,
      },
      {
        path: "privacy",
        element: <PrivacyPage />,
      },
      {
        path: "conditions",
        element: <ConditionPage />,
      },
      {
        path: "support",
        element: <SupportPage />,
      },
      {
        path: "faq" , 
        element: <Faq />
      },
      {
        path: "resources" , 
        element: <Ressource />
      },
      {
        path: "mon-compte",
        element: <EnDevelopment />,
      },
    ],
  },
]);

export default router;
